import AnalyticsManager from "@/cookies/v4_analytics";
import GuardManager from "@/utils/guards";

import * as Turbo from "@hotwired/turbo";
Turbo.start();

window.addEventListener("turbo:load", () => {
    GuardManager.reload();
    AnalyticsManager.reload().catch(window.reportError);
});
